import React from 'react';
import { LinkedinOverview } from './LinkedinOverview';

const TABS = ['overview', 'configuration'] as const;
export type Tab = typeof TABS[number];

type Props = {
  tenant: number;
  hasAccessToConfiguration: boolean;
};

export function LinkedinIntegration({
  tenant,
  hasAccessToConfiguration,
}: Props) {
  return (
    <div className="row ml-4">
      <div className="tab-content w-100" id="TabContent">
        <div className="tab-pane fade active show" role="tabpanel">
          <div className="row justify-content-center">
            <div className="col-8 mt-4 mb-4">
              <div className="card box-shadow-3d mt-md-2 d-flex w-100">
                <div className="card-header">
                  <div className="d-flex align-items-center">
                    <img
                      className="con-map-mk-integration-logo-size"
                      style={{ width: '30px' }}
                      src="/media/integrations/logos/linkedin-logo.svg"
                    />
                    <h5 className="mb-0 ml-3">LinkedIn</h5>
                  </div>
                </div>

                <div className="card-body">
                  <LinkedinOverview
                    tenant={tenant}
                    hasAccessToConfiguration={hasAccessToConfiguration}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
